import Keycloak from 'keycloak-js'
import { env } from '../config/env'
import { SCOPES } from '../config/constants'

// Single shared keycloak-js instance. Public client (PKCE) — no secret.
// Config comes from validated env vars so the URL can differ between local and cloud.
export const keycloak = new Keycloak({
  url: env.VITE_KEYCLOAK_URL,
  realm: env.VITE_KEYCLOAK_REALM,
  clientId: env.VITE_KEYCLOAK_CLIENT_ID,
})

// Shared login options used at EVERY login() call site (interactive button,
// token-refresh fallback, onboarding route). Centralizing the requested scopes
// here is what stops a silent re-login from re-issuing a token WITHOUT them —
// which would make the scope-gated BFF routes 403.
export const LOGIN_OPTIONS = {
  scope: SCOPES,
  redirectUri: window.location.origin + '/',
} as const
